import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { EventOption } from '@frontend/sports/betting-offer/feature/model';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { SportConstant } from '@frontend/sports/common/core/data-access/constants';
import { ForecastComponentMode } from '@frontend/sports/racing/feature/models';
import { trackingConstants } from '@frontend/sports/tracking/feature';

import { getDayOfRace } from '../../../../horse-racing-shared/helpers';
import { HorsesFixtureMarketHelper } from '../../../../horse-racing-shared/services/horses-fixture-market-helper.service';
import { HorsesFixtureParticipantHelper } from '../../../../horse-racing-shared/services/horses-fixture-participant-helper.service';
import { HorsesFixturePricingHelper } from '../../../../horse-racing-shared/services/horses-fixture-pricing-helper.service';
import { RacingService } from '../../../services/racing-service';
import { GreyhoundsPostPicksService } from './greyhounds-post-picks.service';
import { RacingPostBaseComponent } from './racing-post-base.component';

@Component({
    selector: 'ms-racingpost-pick',
    templateUrl: './racingpost-pick.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class RacingpostPickComponent extends RacingPostBaseComponent {
    @Input() tab: string;
    @Input() isracingpostPickDisabled: boolean;
    @Input() participantOptionGroups?: { [id: string]: EventOption[] };
    isForecastSelected: boolean;
    isTricastSelected: boolean;
    sport = SportConstant;

    constructor(
        public sitecore: Sitecore,
        protected override racingService: RacingService,
        protected override horsesFixturePricingHelper: HorsesFixturePricingHelper,
        protected override horsesFixtureMarketHelper: HorsesFixtureMarketHelper,
        protected override greyhoundsPostPicksService: GreyhoundsPostPicksService,
        protected override horsesFixtureParticipantHelper: HorsesFixtureParticipantHelper,
    ) {
        super(racingService, horsesFixturePricingHelper, horsesFixtureMarketHelper, greyhoundsPostPicksService, horsesFixtureParticipantHelper);
    }

    pickSelected($event: boolean): void {
        if (this.tab === ForecastComponentMode.Forecast) {
            this.isForecastSelected = $event;
        } else if (this.tab === ForecastComponentMode.Tricast) {
            this.isTricastSelected = $event;
        }
    }

    getTrackingOptions(): { [key: string]: string } {
        if (this.isSports && this.isGreyhounds) {
            const date = new Date(this.fixture.startDate);
            if (this.tab === ForecastComponentMode.Forecast) {
                this.trackingSource = 'Greyhounds_Racecard/forecast_racingpost';
            } else {
                this.trackingSource = 'Greyhounds_Racecard/tricast_racingpost';
            }
            return {
                [trackingConstants.COMPONENT_MODULE_CUSTOM_NAME]: this.fixture.meeting.name.value,
                [trackingConstants.COMPONENT_MODULE_NAME]: this.trackingSource,
                [trackingConstants.COMPONENT_MODULE_POSITION]: date.getHours() + ':' + date.getMinutes(),
                [trackingConstants.COMPONENT_MODULE_SOURCE]: '',
                [trackingConstants.COMPONENT_BET_SOURCE]: this.trackingSource,
                [trackingConstants.BET_CALENDER]: getDayOfRace(this.fixture.startDate),
            };
        }
        return {};
    }
}
